module.exports = __webpack_public_path__ + "media/components/resort-webcams/static/spinner-30bc526445538dc5c54e0c2f733deaa6.gif";